export default __webpack_public_path__ + "static/media/BannerMotiva3.4adeabe2.png";